import debounce from 'lodash.debounce';

export default {
  data() {
    return {
      resizableHeight: 0,
      resizeObserver: null,
    };
  },
  mounted() {
    this.resizeObserver = new ResizeObserver(this.debounceResize).observe(
      this.$refs.resizableElm
    );
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.unobserve(this.$refs.resizableElm);
    }
  },
  created() {
    this.debounceResize = debounce(this.onResize, 1);
  },
  methods: {
    onResize() {
      if (!this.$refs.resizableElm) {
        console.warn('No resizable element found.');
        return;
      }
      this.resizableHeight =
        this.$refs.resizableElm.getBoundingClientRect().height;
    },
  },
};
